/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';
import { WidgetsDoubleFreeType, WidgetsDoubleType } from '../types';
import { WidgetDoubleFreeMobile } from './WidgetDoubleFreeMobile';
import { WidgetDoubleFreeDesktop } from './WidgetDoubleFreeDesktop';

export const WidgetDoubleFree = ({
  widget,
}: {
  widget: WidgetsDoubleFreeType | WidgetsDoubleType;
}): JSX.Element => {
  const theme: ICustomTheme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'), {
    noSsr: true,
  });
  const isConfigByAdminToDisplayOnMobile: boolean = widget.isMobile;
  const { widgets } = widget;

  return (
    <React.Fragment>
      {isMobileScreen && isConfigByAdminToDisplayOnMobile && (
        <WidgetDoubleFreeMobile widgets={widgets} />
      )}
      {!isMobileScreen && <WidgetDoubleFreeDesktop widgets={widgets} />}
    </React.Fragment>
  );
};
